var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!_vm.$vuetify.theme.dark && (_vm.isAndroid() || !_vm.isIphone()))?_c('v-col',{attrs:{"cols":"12"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }